import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import ImageNotSupportedOutlinedIcon from "@mui/icons-material/ImageNotSupportedOutlined";

const prodURL = "https://club-lab.ru";
const apiUrl =
  window.location.hostname === "localhost" ? "http://localhost:3004" : prodURL;

export default function TrainerMessengerPreview({
  title,
  theme,
  description,
  poster,
  previewMode = "welcome",
  question,
  embedded = false,
}) {
  const answers = question?.answers?.filter((a) => a.label?.trim()) ?? [];

  return (
    <div className={`trainer-preview${embedded ? " trainer-preview--embedded" : ""}`}>
      {!embedded ? (
        <div className="trainer-preview__label">Как увидит сотрудник в мессенджере</div>
      ) : null}
      <div className="trainer-preview__phone">
        <div className="trainer-preview__bubble trainer-preview__bubble--bot">
          {previewMode === "welcome" ? (
            <>
              <div className="trainer-preview__poster">
                {poster ? (
                  <img src={`${apiUrl}/${poster}`} alt="" />
                ) : (
                  <div className="trainer-preview__poster-empty">
                    <ImageNotSupportedOutlinedIcon />
                    <span>Обложка</span>
                  </div>
                )}
              </div>
              <p className="trainer-preview__title">{title || "Название тренажёра"}</p>
              {theme ? <p className="trainer-preview__theme">Тема: {theme}</p> : null}
              <p className="trainer-preview__text">
                {description ||
                  "Приветственное сообщение о режиме тренажёра и кнопка «Старт»."}
              </p>
              <div className="trainer-preview__btn">Старт</div>
            </>
          ) : (
            <>
              {question?.questionMode === "text" || !question?.hasVideo ? (
                <p className="trainer-preview__text">
                  {question?.questionText?.trim() || "Текст вопроса"}
                </p>
              ) : (
                <div className="trainer-preview__video">
                  {question?.screenpath ? (
                    <img src={`${apiUrl}/${question.screenpath}`} alt="" />
                  ) : (
                    <>
                      <VideocamOutlinedIcon />
                      <span>Видео-вопрос</span>
                    </>
                  )}
                </div>
              )}
              {question?.questionMode === "video" && question?.questionText ? (
                <p className="trainer-preview__text">{question.questionText}</p>
              ) : null}
              <p className="trainer-preview__hint">Выберите ответ:</p>
              <div className="trainer-preview__answers">
                {answers.length ? (
                  answers.map((answer) => (
                    <div
                      key={answer.id}
                      className={`trainer-preview__answer${
                        answer.isCorrect ? " trainer-preview__answer--correct" : ""
                      }`}
                    >
                      {answer.label}
                    </div>
                  ))
                ) : (
                  <div className="trainer-preview__answer trainer-preview__answer--ghost">
                    Вариант ответа
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
